module.exports = __webpack_public_path__ + "img/info.ffa4f0c5.png";